import(/* webpackMode: "eager", webpackExports: ["AppShell"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/AppShell/AppShell.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["AppShellHeader"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/AppShell/AppShellHeader/AppShellHeader.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["AppShellMain"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/AppShell/AppShellMain/AppShellMain.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["MantineProvider"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/core/MantineProvider/MantineProvider.mjs");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/node_modules/@mantine/core/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["Notifications"] */ "/home/runner/work/web/web/node_modules/@mantine/notifications/esm/Notifications.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["cleanNotifications","cleanNotificationsQueue","createNotificationsStore","hideNotification","notifications","notificationsStore","showNotification","updateNotification","updateNotificationsState","useNotifications"] */ "/home/runner/work/web/web/node_modules/@mantine/notifications/esm/notifications.store.mjs");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/node_modules/@mantine/notifications/styles.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/src/app/layout.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/runner/work/web/web/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BugsnagErrorBoundary"] */ "/home/runner/work/web/web/src/components/BugsnagErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BugsnagProvider"] */ "/home/runner/work/web/web/src/components/BugsnagProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/components/ConditionalFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/components/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/components/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IncompleteApplicationBanner"] */ "/home/runner/work/web/web/src/components/IncompleteApplicationBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/components/MentorOnboardingRedirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/components/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/components/ui/ErrorModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UpcomingMeetingBanner"] */ "/home/runner/work/web/web/src/components/UpcomingMeetingBanner.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/src/styles/globals.css");
